import React,{useState,useEffect,useCallback} from 'react'
import { Hero } from "shared/components/bulma/hero";
import { sortArrayPipe } from "shared/pipes";
import { v4 as uuidv4 } from 'uuid';
import TableComponent from 'components/table/Table';
import AddComponent from 'components/table/AddComponent';
import {  deleteSupplierById, getSuppliers,setNewSupplier } from 'controllers/Supplier';



function Supplier() {
  const [inputText, setInputText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const [data, setData] = useState([]);
  
    const handleChange = (event) => {
        setInputText(event.target.value);
      };
  const handleClick = () => {
    const id = uuidv4()
    if (inputText ) {
        setNewSupplier({
            id: id, value:inputText,
            label: inputText,
            market: window.localStorage.getItem('country'),
        }, setData, inputText, setInputText, id,setIsLoading,isLoading)
    }

  };
  
async function dataStream(callback) {

  const size = await getSuppliers(window.localStorage.getItem('country'));
  callback(sortArrayPipe.transform(size, 'value'));
  }
  const cachedFn = useCallback( async() => {    
    await dataStream((values) => {
        setData(values)
    });
  },[])
  
    useEffect(() => {
      cachedFn()
      
  },[cachedFn])
  const HandleDelete = (id) => {
    deleteSupplierById(id,setData,isDeleting, setIsDeleting)
    };
    return (
      <>
      <div style={{display:'flex',justifyContent:'center',marginTop:'2%'}}>
          <AddComponent
            label="Add Supplier"
            inputText={inputText}
            handleClick={handleClick}
            handleChange={handleChange}
            placeholder="New Supplier"/>
      </div>
            <Hero>
          <TableComponent
            data={data}
            HandleDelete={HandleDelete}
            updateUrl="update-supplier"
          
          />
            </Hero>
            </>
  )
}

export default Supplier;